// BTA Guardrail: Blocks checkout if required BookThatApp dates are missing
document.addEventListener("DOMContentLoaded", function() {
    
    // Inject CSS Lockdown Styles
    if (!document.getElementById('bta-lockdown-styles')) {
        const style = document.createElement('style');
        style.id = 'bta-lockdown-styles';
        style.innerHTML = `
            body.bta-lockdown .bta-dynamic-buttons-wrapper,
            body.bta-lockdown .additional-checkout-buttons,
            body.bta-lockdown .shopify-payment-button,
            body.bta-lockdown .cart__dynamic-checkout-buttons,
            body.bta-lockdown [data-shopify-button-container],
            body.bta-lockdown .paypal-logo,
            body.bta-lockdown .paypal-button {
                display: none !important;
                pointer-events: none !important;
                opacity: 0 !important;
            }
        `;
        document.head.appendChild(style);
    }

    function checkCartAndEnforce() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                let missingDate = false;
                
                cart.items.forEach(item => {
                    // Check if it's a Queen Bee by checking properties for Date
                    if (item.title.toLowerCase().includes('queen') || item.product_type.toLowerCase().includes('queen')) {
                        if (!item.properties || !item.properties['Date']) {
                            missingDate = true;
                        }
                    }
                });

                const checkoutBtns = document.querySelectorAll('button[name="checkout"], input[name="checkout"], #checkout');
                let warningBanner = document.getElementById('bta-guardrail-warning');
                
                if (missingDate) {
                    // Enable CSS Lockdown
                    document.body.classList.add('bta-lockdown');
                    
                    checkoutBtns.forEach(btn => {
                        btn.disabled = true;
                        btn.style.opacity = '0.5';
                        btn.style.cursor = 'not-allowed';
                    });
                    
                    if (!warningBanner) {
                        warningBanner = document.createElement('div');
                        warningBanner.id = 'bta-guardrail-warning';
                        warningBanner.style.backgroundColor = '#f8d7da';
                        warningBanner.style.color = '#721c24';
                        warningBanner.style.padding = '15px';
                        warningBanner.style.margin = '10px 0';
                        warningBanner.style.borderRadius = '5px';
                        warningBanner.style.textAlign = 'center';
                        warningBanner.style.fontWeight = 'bold';
                        warningBanner.innerText = 'It looks like your Queen Bee is missing a shipment date! Please remove this item and re-add it with a date selected to continue to checkout.';
                        
                        const form = document.querySelector('form[action="/cart"]');
                        if (form) {
                            form.insertBefore(warningBanner, form.firstChild);
                        }
                    } else {
                        warningBanner.style.display = 'block';
                    }
                } else {
                    // Disable CSS Lockdown
                    document.body.classList.remove('bta-lockdown');
                    
                    checkoutBtns.forEach(btn => {
                        btn.disabled = false;
                        btn.style.opacity = '1';
                        btn.style.cursor = 'pointer';
                    });
                    
                    if (warningBanner) {
                        warningBanner.style.display = 'none';
                    }
                }
            })
            .catch(err => console.error('BTA Guardrail Error:', err));
    }

    checkCartAndEnforce();

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
        this.addEventListener('load', function() {
            if (this.responseURL.includes('/cart/add') || this.responseURL.includes('/cart/change') || this.responseURL.includes('/cart/update') || this.responseURL.includes('/cart.js')) {
                checkCartAndEnforce();
            }
        });
        originalOpen.apply(this, arguments);
    };
    
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
        const response = await originalFetch.apply(this, args);
        const url = args[0] && typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
        if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart.js')) {
            response.clone().json().then(() => checkCartAndEnforce()).catch(() => checkCartAndEnforce());
        }
        return response;
    };
});